/**
 * Report errors from all production environments, and stage
 * @param {string} env
 */
export function shouldReportToSentry(env) {
  if (!env) console.log("Missing config.environment");
  if (!env || typeof env !== "string") return false;
  return env.startsWith("prod") || env === "stage";
}
